var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuality = function SvgQuality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#691B33",
    d: "M4.261 4.194 1.913 8.493 8.749 16l6.836-7.528-2.349-4.278H4.261Zm8.137.839-1.154 2.872-1.803-2.872h2.957ZM10.3 7.968H7.176l1.552-2.495 1.573 2.495ZM8.036 5.033 6.254 7.884 5.12 5.034h2.915Zm-3.586.566.944 2.37H3.15l1.3-2.37ZM3.38 8.807h2.35l1.803 4.53-4.152-4.53ZM8.75 14.26 6.63 8.891l.021-.084h4.173l.02.084.022.021-2.118 5.347Zm1.237-.901 1.803-4.53h2.328l-4.13 4.53Zm2.14-5.39.943-2.348 1.3 2.348h-2.244ZM9.168 0h-.839v2.726h.839V0ZM17.487 2.215l-.58-.606-2.134 2.048.581.605 2.133-2.047ZM2.714 3.658.581 1.611l-.58.605 2.132 2.048.581-.606Z"
  })));
};
export default SvgQuality;